export * from './home'



// WEBPACK FOOTER //
// ./node_modules/_tslint-loader@3.5.4@tslint-loader!./src/views/home/index.ts